"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["INTEGRATION"] = "Integration";
    Environment["PREPRODUCTION"] = "Preproduction";
    Environment["PRODUCTION"] = "Production";
})(Environment = exports.Environment || (exports.Environment = {}));
